import { post, get } from "./requests";

export async function sendMessage({ content, chatId, token }) {
    return await post("message/send/agent", { content, chatId }, token);
}

export async function getMessages({ chatId, token }) {
    return await get("message/get/agent/" + chatId, token);
}

